import { LitElement } from "lit";
import { I18nController } from "../i18n/lib/lit-controller.ts";

/** Lit base that refreshes the element when the active locale changes. */
export abstract class AlttoLitElement extends LitElement {
  protected readonly i18nController = new I18nController(this);
}

/** Altto Lit base for components styled by the shared light-DOM stylesheet. */
export abstract class AlttoLightDomElement extends AlttoLitElement {
  override createRenderRoot() {
    return this;
  }
}

/** Light-DOM element whose host should not add a layout box around its render output. */
export abstract class AlttoLightDomContentsElement extends AlttoLightDomElement {
  override connectedCallback() {
    super.connectedCallback();
    this.style.display = "contents";
  }
}
